import React, {useEffect} from "react";
import useForm from "../../hooks/useForm";
import TextInput from "../TextInput";
import CheckboxInput from "../CheckboxInput";
import "./style.scss";

function FormPanel({
  id,
  title,
  btnName,
  submitCallback,
  model,
  validateLength,
  validatePattern,
  countryAndIdTypeValidationPattern,
  labelName,
  placeholder,
  getInputData,
  formattedIDVerificationList,
  isSuccess,
  isWelcomePage,
}) {
  const [inputs, setInputs, setSubmit] = useForm(
    formattedIDVerificationList,
    model,
    submitCallback,
    validateLength,
    validatePattern,
    countryAndIdTypeValidationPattern,
    labelName,
    placeholder,
    isSuccess,
    isWelcomePage
  );

  useEffect(() => {
    getInputData && getInputData(inputs);
  }, [inputs]);

  const Components = {
    TextInput,
    CheckboxInput,
  };

  const capitalize = (expression) =>
    expression.charAt(0).toUpperCase() + expression.slice(1);

  const renderInput = (input) => {
    const Component = Components[capitalize(input.type) + "Input"];
    if (placeholder) {
      return (
        <Component
          key={input.name}
          setInputs={setInputs}
          {...input}
          labelName={labelName}
          placeholder={placeholder}
          isSuccess={isSuccess}
          isWelcomePage={isWelcomePage}
        />
      );
    } else {
      return (
        <Component
          key={input.name}
          setInputs={setInputs}
          {...input}
          labelName={labelName}
          isSuccess={isSuccess}
          isWelcomePage={isWelcomePage}
        />
      );
    }
  };
  return (
    <section className="form-container">
      <form
        id={id}
        autoComplete="off"
        className="login-form-input"
        onSubmit={setSubmit}
        noValidate="novalidate"
      >
        {inputs.map((input) => renderInput(input))}
        {btnName ? (
          <div>
            <input type="submit" onClick={setSubmit} value={btnName} />
          </div>
        ) : null}
      </form>
    </section>
  );
}

export default FormPanel;
